<template>
  <b-container fluid>
    <!-- propGideUser.user_name -->
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row" v-if="propAdmission">
          <div class="col-12 col-sm-7">
            <h4>
              <i class="fa-regular fa-file-lines" aria-hidden="true" style="font-size: 20px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              <span v-if="propGideUser && propGideUser.user_name">{{ propGideUser.user_name }}</span>
            </h4>
          </div>
          <div class="col-12 col-sm-5">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="yjsDocsAdd">{{cvbtnAddNew}}</b-button>
            <b-button v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="openDocumentTypeList">Manage Document Types</b-button>
          </div>
        </div>
        <div class="iq-card row p-3" v-if="propAdmission">
          <b-col lg="10" xl="10">
            <b-row>
              <!-- Backend Search -->
               <b-col class="col-12 mb-3">
                <b-form-input class="form-control"
                  @input="searchdocsWithParams"
                  v-model="search_param"
                  type="search"
                  :placeholder="cvSearchText"></b-form-input>
                </b-col><!-- Backend Search -->
            </b-row>
          </b-col>
        </div>
        <div class="iq-card row p-3">
          <b-col class="container_minheight" md="12" v-if="docsObjList && docsObjList.length > 0">
            <b-table
              hover
              responsive
              :items="docsObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentBatchNo"
              :per-page="dataPerPage"
              >
              <template v-slot:cell(yjsdocs_name)="data">
                <span>{{ data.item.yjsdocs_name.length > 100 ? data.item.yjsdocs_name.substring(0, 100) + ' ...' : data.item.yjsdocs_name}}</span><br>
                <b-badge v-if="data.item.is_extracurricular === 1" class="pointer ml-1" variant="success mr-1 mb-1" size="sm">Personal</b-badge>
                <b-badge v-if = "data.item.deleted == '1'" style="background-color: red !important;">Deleted</b-badge><br>
                <b-button v-if="!data.item.editable" class="actionIcon mr-1" @click="yjsDocsEdit('MODAL', data.item)"><i class="ri-ball-pen-fill m-0 font-size-20"></i></b-button>
                <b-button class="actionIcon mr-1" title="Edit Document" @click="DocumentEdit(data.item)" size="sm"><i class="fa-solid fa-users-line m-0 font-size-20"></i></b-button>
                <b-button v-if="data.item.yjsdocs_google_doc_url" class="actionIcon mr-1" title="Open in Google Docs" @click="openInGoogleDocs(data.item)" size="sm"><i class="fa-brands fa-google m-0 font-size-20"></i></b-button>
                <b-button v-if="hasAttachment(data.item) > 0" class="actionIcon mr-1" title="View Attached Documents" @click="yjsDocsEdit('MODAL', data.item)" size="sm"><i class="fa-solid fa-file-pdf m-0 font-size-20"></i></b-button>
                <b-button class="actionIcon mr-1" @click="publishUnpublish(data.item)" size="sm">
                  <i v-if="data.item.deleted == '0'" class="ri-delete-bin-line m-0 font-size-20" title="Delete"></i>
                  <i v-else class="fa fa-refresh m-0 font-size-20" title="Restore"></i>
                </b-button>
              </template>
              <template v-slot:cell(yjsdocs_code)="data">
                <span>{{data.item.yjsdocs_code}}</span><br>
                <span v-if="data.item.org_name"><b>{{data.item.org_name}}</b></span>
              </template>
              <template v-slot:cell(yjsdocs_state)="data">
                <b-badge class="text-wrap w-125px mb-2" :style="getDocStateColorCode(data.item.yjsdocs_state)">
                  {{data.item.yjsdocs_state_desc}}
                </b-badge>
              </template>
            </b-table>
          </b-col>
          <b-col class="container_minheight" md="12" v-else>
            No data found
          </b-col>
          <b-col sm="12" md="12" class="my-1" v-if="propAdmission">
            <b-row>
              <b-col sm="12" md="7">
                <b-btn variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
              </b-col>
              <b-col sm="5" md="5">
                <b-pagination
                  v-model="currentBatchNo"
                  :total-rows="totalRows"
                  :per-page="dataPerPage"
                  align="fill"
                  size="sm"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModeldocAdd"
      scrollable
      :title="cvAddModalHeader"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      :noCloseOnBackdrop="true"
    >
      <YjsDocsAttach :propUserDetails="propGideUser" @emitClosedocAddModal="closedocAddModal" :propOpenedInEditMode="propOpenedInEditMode" :propUspExcId="propUspExcId" :propYJSDocId="propYJSDocId"/>
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="yjsDocsAdd('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closedocAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showEditDocumentModal"
      scrollable
      :title="cvEditDocumentModalHeader"
      size="xxl"
      hide-header
      hide-footer
      :noCloseOnBackdrop="true"
    >
      <SpcmEssayEditor :propYJSDocObj="documentEditObj" :propOpenedInModal="true" @emitCloseuserYjsdocsHistoryAddModal="CloseuserYjsdocsHistoryAddModal" @emitRefreshYjsDoc="emitRefreshYjsDoc"/>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import { YjsDocs } from "../../../FackApi/api/YjsDocs.js"
import YjsDocsAttach from "./YjsDocsAttach.vue"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit.js"
import userPermission from "../../../Utils/user_permission.js"
import SpcmEssayEditor from "../SPCM/SpcmEssayEditor.vue"
import config from "../../../Utils/config.js"

export default {
  name: "DocsList",
  components: {
    YjsDocsAttach,
    SpcmEssayEditor
  },
  props: {
    propGideUser: {
      type: Object
    },
    propYjsDocObj: {
      type: Object
    },
    propAdmission: {
      type: Boolean,
      default: true
    },
    propAdmissionOrg: {
      type: String
    }
  },
  data () {
    return {
      apiName: "yjsdocs_list",
      cvCardTitle: "Document List",
      cvbtnAddNew: "Add",
      cvSearchText: "Type to Search",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit Documment",
      cvEditDocumentModalHeader: "Edit Document",
      cvAddModalHeader: "Add Document",
      cvbtnModalCancel: "Cancel",
      cvbtnModalExpand: "Expand",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "doc",
      showModeldocAdd: false,
      showEditDocumentModal: false,
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "# ", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "Document name", key: "yjsdocs_name", class: "text-left align-text-top", sortable: true },
        { label: "Document Type", key: "yjsdocs_code", class: "text-left align-text-top", sortable: true },
        { label: "Review Status", key: "yjsdocs_state", class: "text-left align-text-top", sortable: true }
      ],
      docsObjList: [],
      docsEditObj: null,
      documentEditObj: null,
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      delObj: null,
      whereFilter: {},
      search_param: "",
      deleted: "",
      currentBatchNo: 1,
      dataPerPage: 100,
      showLoadMoreBtn: true,
      gidUserId: null,
      propsyjsDocAddObj: null,
      cvbtnEditDocumentModalCancel: "Save & Close",
      propOpenedInEditMode: false,
      propUspExcId: null,
      propYJSDocId: null
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async beforeMount () {
    // Auth Access for Current User Role
    if (this.userData.user_role == "USERROLE11114") {
      // We will display only the sessions of the user, It is necessary when the user has multiple sessions and he/she wants to view the session
      // DONT CARE CASE
    }
    else if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()
    this.gidUserId = this.propGideUser && this.propGideUser.user_id ? this.propGideUser.user_id : this.userData.user_id
    this.yjsDocsList()
  },
  methods: {
    /**
     * searchdocsWithParams
     */
    async searchdocsWithParams () {
      if (this.whereFilter.search_param.length == 0) {
        this.showLoadMoreBtn = true
      }
      this.currentBatchNo = 1
      this.yjsDocsList()
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.yjsDocsList(true)
    },
    /**
     * yjsDocsList
     */
    async yjsDocsList (loadViaLoadMore = false) {
      try {
        if (!this.propAdmission) {
          this.whereFilter.deleted = "0"
        }

        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.search_param = this.search_param
        this.whereFilter.gide_user_id = this.gidUserId
        this.whereFilter.gide_user_role = this.userData.user_role
        this.whereFilter.org_id = this.propAdmissionOrg
        let docsListResp = await YjsDocs.yjsDocsList(this, this.whereFilter)
        if (docsListResp.resp_status) {
          if (this.whereFilter.search_param.length >= 0 && !loadViaLoadMore) {
            this.docsObjList = [ ...docsListResp.resp_data.data ]
          }
          else {
            this.docsObjList = [ ...this.docsObjList, ...docsListResp.resp_data.data ]
          }
          this.showLoadMoreBtn = true

          // Adding the serial numbers:
          this.docsObjList.forEach((s, index) => { s.id = index + 1 })
          this.totalRows = this.docsObjList.length
        }
        else {
          this.showLoadMoreBtn = false
        }
      }
      catch (err) {
        console.error("Exception occurred at yjsDocsList() and Exception:", err)
      }
    },
    /**
     * yjsDocsAdd
     */
    yjsDocsAdd (type) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/admin/docs_add")
        }
        else {
          this.propsyjsDocAddObj = {
            module_name: this.propYjsDocObj.module_name,
            module_object_id: this.propYjsDocObj.spcm_id
          }
          this.propUspExcId = null
          this.propOpenedInEditMode = false
          this.showModeldocAdd = true
        }
      }
      catch (err) {
        console.error("Exception occurred at yjsDocsAdd() and Exception:", err.message)
      }
    },
    /**
     * yjsDocsEdit
     */
    yjsDocsEdit (type, item) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/admin/docs_edit/" + this.docsEditObj.yjsdocs_id)
        }
        else {
          this.propOpenedInEditMode = true
          this.propUspExcId = item.module_object_id
          this.propYJSDocId = item.yjsdocs_id
          this.showModeldocAdd = true
        }
      }
      catch (err) {
        console.error("Exception occurred at yjsDocsEdit() and Exception:", err.message)
      }
    },
    /**
     * Document Edit
     */
    DocumentEdit (item) {
      try {
        this.documentEditObj = item
        this.showEditDocumentModal = true
      }
      catch (err) {
        console.error("Exception occurred at DocumentEdit() and Exception:", err.message)
      }
    },
    /**
     * open Attached Document
     */
    openAttachedDocument (docData) {
      window.open(docData.yjsdocs_google_doc_url, "_blank")
    },
    /**
     * closedocAddModal
     */
    closedocAddModal () {
      this.yjsDocsList()
      this.showModeldocAdd = false
    },
    /**
     * openCollaborativeEditor
     */
    openCollaborativeEditor (yjsdocs) {
      window.open(`/spcm_essay_editor/${yjsdocs.yjsdocs_id}`)
    },
    /**
     * CloseuserYjsdocsHistoryEditModal
     */
    async CloseuserYjsdocsHistoryAddModal () {
      this.showEditDocumentModal = false
    },
    /**
     * emitRefreshYjsDoc
     */
    async emitRefreshYjsDoc (docId) {
      await this.yjsDocsList()
      this.documentEditObj = this.docsObjList.find(e => e.yjsdocs_id == docId)
    },
    /**
     * getDocStateColorCode
     */
    getDocStateColorCode (state) {
      return `vertical-align: middle; color: #FFF; background: ${config.YjsDocsStateColors[state]} !important;`
    },
    /**
     * open Document Type List
     */
    openDocumentTypeList () {
      window.open(`/uexcc_type_list`)
    },
    /**
     * has Document Attached
     */
    hasAttachment (item) {
      try {
        if (item.exc_attach) {
          let attachment = JSON.parse(item.exc_attach)
          return attachment.length
        }
        else if (item.yjsdocs_attach) {
          let attachment = JSON.parse(item.yjsdocs_attach)
          return attachment.length
        }
      }
      catch (e) {
        console.error("hasAttachment: Ex. in JSON parsing", item)
      }
    },
    /**
     * Publish/UnPublish Yjs Doc
     */
    async publishUnpublish (yjsDocs) {
      let payload = {
        yjsdocs_id: yjsDocs.yjsdocs_id,
        exc_id: yjsDocs.module_object_id,
        is_extracurricular: yjsDocs.is_extracurricular,
        deleted: null
      }

      if (yjsDocs.deleted === 0) {
        // yjsDoc is published then unpublish
        payload.deleted = 1
        this.toastMsg = "Hide from Students But not deleted you can restore"
        this.toastVariant = "success"
        this.showToast = true
      }
      else if (yjsDocs.deleted === 1) {
        // yjsDoc is deleted then publish
        payload.deleted = 0
        this.toastMsg = "Now student can see this"
        this.toastVariant = "success"
        this.showToast = true
      }
      else {
        return
      }

      let docsDelResp = await YjsDocs.yjsDocsPublishUnpublish(this, payload)
      if (docsDelResp.resp_status === true) {
        yjsDocs.deleted = payload.deleted
      }
      else {
        ApiResponse.responseMessageDisplay(this, docsDelResp)
      }
    }
  }
}
</script>
<style>
.close-x{
  font-size: 30px !important;
  height: 20px !important;
  display: block;
  position: relative;
  top: -12px;
}
.close-x-button{
  padding: 0px;
}
</style>
